import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const LMT_ENHCMT_saveBsDocUpload_API_CALL = createAsyncThunk(
  'LMT_ENHCMT_saveBsDocUpload_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({
      type: 'LMT_ENHCMT_saveBsDocUpload_API_CALL/pending',
      payload: {},
    });
    const { saveBsDocUploadPayload, successFn, errorFn } = payload;
    const {
      customerId,
      authorization,
      filePath,
      proofId,
      methodType,
      requestType,
      journeyType,
      password,
    } = saveBsDocUploadPayload;
    const { selectedBankObj, bankStatementPassword } =
      getState().limitEnhancementJourney;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'docuploadforweb',
      payload: {
        proofId: 1,
        requestType: 'SAVE_BANK_STATEMENT',
        filePath: [...filePath],
        bankStatement: {
          instiId: selectedBankObj.institutionId,
          bankName: selectedBankObj.bankName,
          bankId: selectedBankObj.bankId,
        },
        customerId,
        password: bankStatementPassword,
        journeyType: 'LIMIT_ENHANCE',
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      otherPayloadDetailsPresent: true,
      headers: { authorization, customerid: customerId },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const saveBsDocuploadResponse = res;
        if (successFn) successFn(res);
        dispatch({
          type: 'LMT_ENHCMT_saveBsDocUpload_API_CALL/fulfilled',
          payload: saveBsDocuploadResponse,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        if (errorFn) errorFn(err);
        dispatch({
          type: 'LMT_ENHCMT_saveBsDocUpload_API_CALL/rejected',
          payload: err,
        });
      },
    });
  }
);

export const LMT_ENHCMT_saveBsDocUpload_API_CALL_extrareducer = {
  [LMT_ENHCMT_saveBsDocUpload_API_CALL.pending]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = true;
  },
  [LMT_ENHCMT_saveBsDocUpload_API_CALL.fulfilled]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = false;

    state.saveBsDocUploadAPICall.isSuccess = true;
    state.saveBsDocUploadAPICall.isError = false;
    state.saveBsDocUploadAPICall.response = action.payload;
  },
  [LMT_ENHCMT_saveBsDocUpload_API_CALL.rejected]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = false;

    state.saveBsDocUploadAPICall.isSuccess = false;
    state.saveBsDocUploadAPICall.isError = true;
    state.saveBsDocUploadAPICall.response = action.payload;
  },
};
